import axios from "axios";
import { Button } from "devextreme-react";

export default function InvoiceNoCell(props) {
  const { data } = props;

  const onFileInvoiceIconClick = async (e) => {
    axios
      .get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/paytStatus/inv/${data.data.contrNo}/${data.data.invNo}`,
        {
          responseType: "arraybuffer",
          headers: {
            "Content-Type": "blob",
          },
        }
      )
      .then((result) => {
        const link = document.createElement("a");
        const fileName = "invoice.xlsx";

        link.setAttribute("download", fileName);
        link.href = URL.createObjectURL(new Blob([result.data]));

        document.body.appendChild(link);

        link.click();
        link.remove();
      });
  };

  return (
    <>
      <div style={{ float: "left", marginTop: "5px" }}>{data.value}</div>
      <Button
        style={{ margin: 0, float: "left", height: "20px" }}
        icon="fa-solid fa-file-invoice-dollar"
        onClick={onFileInvoiceIconClick}
      />
    </>
  );
}
